const ITEMS = [
  "Advertising",
  "Digital",
  "Social",
];

const Row = ({ ariaHidden = false }) => (
  <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={item} className="flex items-center">
        <span
          className={`whitespace-nowrap px-6 font-display text-3xl font-extrabold uppercase tracking-tight md:px-10 md:text-6xl ${
            i % 2 === 0 ? "text-white" : "text-outline"
          }`}
        >
          {item}
        </span>
        <span className="h-3 w-3 rounded-full bg-vermilion md:h-4 md:w-4" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-white/10 py-6 md:py-8"
    >
      <div className="marquee-track flex w-max">
        <Row />
        <Row ariaHidden />
      </div>
    </section>
  );
}
